import { GraphQLClient } from 'graphql-request';
import { gql } from 'urql';
import {
  CreateSpendingCategoryEstimateInput,
  Mutation,
  Query,
  QuerySpendingCategoryEstimatesArgs,
  UpdateSpendingCategoryEstimateInput,
} from '../generated/graphql';
import { SpendingCategoryEstimateFragment } from './fragments';

const getSpendingCategoryEstimatesQuery = gql`
  ${SpendingCategoryEstimateFragment}
  query SpendingCategoryEstimates($householdID: ID!, $cursor: String) {
    spendingCategoryEstimates(householdID: $householdID, cursor: $cursor) {
      items {
        ...SpendingCategoryEstimateFragment
      }
    }
  }
`;

export const clientGetSpendingCategoryEstimates = async (
  client: GraphQLClient,
  args: QuerySpendingCategoryEstimatesArgs
) => {
  return (
    await client.request<Pick<Query, 'spendingCategoryEstimates'>>(
      getSpendingCategoryEstimatesQuery,
      args
    )
  ).spendingCategoryEstimates;
};

const createSpendingCategoryEstimateMutation = gql`
  ${SpendingCategoryEstimateFragment}
  mutation CreateSpendingCategoryEstimate(
    $input: CreateSpendingCategoryEstimateInput!
  ) {
    createSpendingCategoryEstimate(input: $input) {
      spendingCategoryEstimate {
        ...SpendingCategoryEstimateFragment
      }
    }
  }
`;

export const clientCreateSpendingCategoryEstimate = async (
  client: GraphQLClient,
  input: CreateSpendingCategoryEstimateInput
) => {
  return (
    await client.request<Pick<Mutation, 'createSpendingCategoryEstimate'>>(
      createSpendingCategoryEstimateMutation,
      { input }
    )
  ).createSpendingCategoryEstimate;
};

const updateSpendingCategoryEstimateMutation = gql`
  ${SpendingCategoryEstimateFragment}
  mutation UpdateSpendingCategoryEstimate(
    $input: UpdateSpendingCategoryEstimateInput!
  ) {
    updateSpendingCategoryEstimate(input: $input) {
      spendingCategoryEstimate {
        ...SpendingCategoryEstimateFragment
      }
    }
  }
`;

export const clientUpdateSpendingCategoryEstimate = async (
  client: GraphQLClient,
  input: UpdateSpendingCategoryEstimateInput
) => {
  return (
    await client.request<Pick<Mutation, 'updateSpendingCategoryEstimate'>>(
      updateSpendingCategoryEstimateMutation,
      { input }
    )
  ).updateSpendingCategoryEstimate;
};
